import React, { useEffect, useState, useRef } from "react";
// import Logo from "../../assets/images/new-logo.png";
import { Link, NavLink } from "react-router-dom";
import "./_navbar.scss";
import { useLocation } from "react-router-dom";
import Logo from "../../assets/images/logo.png";

import Accordion from "react-bootstrap/Accordion";

function NavBar() {
  const prevUrlRef = useRef(null);

  const location = useLocation();
  const [showNav, setShowNav] = useState(true);

  return (
    <>
      <div className="enquiry-nav">
        <p className="offset-md-2">Have any question? +968 547856 254</p>
      </div>
      <div className="handles-nav col-md-5 offset-md-7">
        {" "}
        <ul className="list-inline socials-list offset-md-4">
          <li className="list-inline-item ">
            <div className="socials">
              <a href="#" target="_blank">
                <i class="icofont-facebook"></i>
              </a>
            </div>
          </li>{" "}
          <li className="list-inline-item socials">
            <a href="#" target="_blank">
              <i class="icofont-linkedin"></i>
            </a>
          </li>{" "}
          <li className="list-inline-item socials">
            <a href="#" target="_blank">
              <i class="icofont-instagram"></i>
            </a>
          </li>{" "}
          <li className="list-inline-item socials">
            <a href="#" target="_blank">
              <i class="icofont-twitter"></i>
            </a>
          </li>
        </ul>
      </div>
      <div className="col-md-12 fixed-nav col-12">
        {" "}
        <div id="nav" className="flexy col-md-10 offset-md-2">
          <div className="logo-holder  col-md-2 flexy  col-3">
            {" "}
            <Link to={"/"}>
              {" "}
              <img className="" src={Logo} alt="Scholar" />
            </Link>
          </div>

          <nav class="menu dn">
            <ol>
              <li class="menu-item active">
                <NavLink to={"/"}>Home</NavLink>
              </li>
              <li class="menu-item">
                <NavLink href="#0">About</NavLink>
                <ol class="sub-menu">
                  <li class="menu-item">
                    <NavLink
                      to={"/welcome"}
                      className="menu-links list-group-item list-group-item-action"
                      type="button"
                    >
                      Welcome
                    </NavLink>
                  </li>
                  <li class="menu-item">
                    <NavLink
                      to={"/phylosophy"}
                      className="menu-links list-group-item list-group-item-action"
                      type="button"
                    >
                      Phylosophy
                    </NavLink>
                  </li>
                  <li class="menu-item">
                    <NavLink
                      to={"/directory"}
                      className="menu-links list-group-item list-group-item-action"
                      type="button"
                    >
                      Directory
                    </NavLink>
                  </li>
                  <li class="menu-item">
                    <NavLink
                      to={"/degree-structure"}
                      className="menu-links list-group-item list-group-item-action"
                      type="button"
                    >
                      Degree Structure
                    </NavLink>
                  </li>{" "}
                  <li class="menu-item">
                    <NavLink
                      to={"/contact"}
                      className="menu-links list-group-item list-group-item-action"
                      type="button"
                    >
                      Contact
                    </NavLink>
                  </li>
                </ol>
              </li>{" "}
              <li class="menu-item">
                <a href="#0">studing physics</a>
                <ol class="sub-menu">
                  <li>
                    {" "}
                    <NavLink
                      to={"/physics-overview"}
                      className="menu-links list-group-item list-group-item-action"
                      type="button"
                    >
                      Studing Physics Overview
                    </NavLink>
                  </li>
                  <li>
                    {" "}
                    <NavLink
                      to={"/undergraduates"}
                      className="menu-links list-group-item list-group-item-action"
                      type="button"
                    >
                      Prospective Undergraduates
                    </NavLink>
                  </li>
                  <li>
                    {" "}
                    <NavLink
                      to={"/current-undergraduates"}
                      className="menu-links list-group-item list-group-item-action"
                      type="button"
                    >
                      Current Undergraduates
                    </NavLink>
                  </li>
                  <li>
                    {" "}
                    <NavLink
                      to={"/post-undergraduate"}
                      className="menu-links list-group-item list-group-item-action"
                      type="button"
                    >
                      Postgraduates
                    </NavLink>
                  </li>
                </ol>
              </li>
              <li class="menu-item">
                <NavLink href="#0">COURSES</NavLink>
                <ol class="sub-menu">
                  <li class="menu-item">
                    <NavLink
                      to={"/course-page"}
                      className="menu-links list-group-item list-group-item-action"
                      type="button"
                    >
                      Undergraduate Courses
                    </NavLink>
                  </li>
                  <li class="menu-item">
                    <NavLink
                      to={"/pgd-courses"}
                      className="menu-links list-group-item list-group-item-action"
                      type="button"
                    >
                      Postgraduate Courses
                    </NavLink>
                  </li>
                </ol>
              </li>
              <li class="menu-item">
                <a href="#0">research</a>
                <ol class="sub-menu">
                  <li>
                    {" "}
                    <NavLink
                      to={"/research-overview"}
                      className="menu-links list-group-item list-group-item-action"
                      type="button"
                    >
                      Research Overview
                    </NavLink>
                  </li>
                  <li>
                    {" "}
                    <NavLink
                      to={"/research-groups"}
                      className="menu-links list-group-item list-group-item-action"
                      type="button"
                    >
                      Research Groups
                    </NavLink>
                  </li>
                  <li>
                    {" "}
                    <NavLink
                      to={"/research-programmes"}
                      className="menu-links list-group-item list-group-item-action"
                      type="button"
                    >
                      Research Programmes
                    </NavLink>
                  </li>
                  <li>
                    {" "}
                    <NavLink
                      to={"/serminars"}
                      className="menu-links list-group-item list-group-item-action"
                      type="button"
                    >
                      Talks, Serminars & Events
                    </NavLink>
                  </li>
                </ol>
              </li>
              <li class="menu-item">
                {" "}
                <NavLink class="menu-item" to={"/news-page"}>
                  news
                </NavLink>
              </li>
              <li class="menu-item">
                {" "}
                <NavLink class="menu-item" to={"/alumni"}>
                  alumni
                </NavLink>
              </li>
            </ol>
          </nav>
          <div className="col-md-2">&nbsp;</div>
        </div>
      </div>

      <div className=" mobile-navigation ">
        <div className="phone ">
          <div className="menu">
            <div class="list-group options ">
              <NavLink to={"/"} className="menu-navs">
                {" "}
                <button
                  type="button"
                  class="list-group-item list-group-item-action"
                  onClick={() => {
                    document
                      .querySelector(".phone")
                      .classList.toggle("active3");
                  }}
                >
                  Home
                </button>
              </NavLink>{" "}
              <Accordion defaultActiveKey="">
                <Accordion.Item eventKey="0">
                  <Accordion.Header className="menu-navs">
                    <button
                      type="button"
                      className="list-group-item list-group-item-action m-accord menu-navs"
                    >
                      About
                    </button>
                  </Accordion.Header>
                  <Accordion.Body>
                    <div className="col-md-12 mobile-menu">
                      {" "}
                      <ul class="list-unstyled">
                        <li>
                          <NavLink
                            to={"/welcome"}
                            className="menu-links list-group-item list-group-item-action"
                            type="button"
                            onClick={() => {
                              document
                                .querySelector(".phone")
                                .classList.toggle("active3");
                            }}
                          >
                            Welcome Address
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={"/phylosophy"}
                            className="menu-links list-group-item list-group-item-action"
                            type="button"
                            onClick={() => {
                              document
                                .querySelector(".phone")
                                .classList.toggle("active3");
                            }}
                          >
                            Phylosophy
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={"/directory"}
                            className="menu-links list-group-item list-group-item-action"
                            type="button"
                            onClick={() => {
                              document
                                .querySelector(".phone")
                                .classList.toggle("active3");
                            }}
                          >
                            Directory
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={"/degree-structure"}
                            className="menu-links list-group-item list-group-item-action"
                            type="button"
                            onClick={() => {
                              document
                                .querySelector(".phone")
                                .classList.toggle("active3");
                            }}
                          >
                            Degree Structure
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            to={"/contact"}
                            className="menu-links list-group-item list-group-item-action"
                            type="button"
                            onClick={() => {
                              document
                                .querySelector(".phone")
                                .classList.toggle("active3");
                            }}
                          >
                            Contact
                          </NavLink>
                        </li>
                      </ul>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <NavLink to={"/course-page"} className="menu-navs">
                {" "}
                <button
                  type="button"
                  class="list-group-item list-group-item-action"
                  onClick={() => {
                    document
                      .querySelector(".phone")
                      .classList.toggle("active3");
                  }}
                >
                  Courses
                </button>
              </NavLink>{" "}
              <Accordion defaultActiveKey="">
                <Accordion.Item eventKey="0">
                  <Accordion.Header className="menu-navs">
                    <button
                      type="button"
                      className="list-group-item list-group-item-action m-accord menu-navs"
                    >
                      Studying Physics
                    </button>
                  </Accordion.Header>
                  <Accordion.Body>
                    <ul class="list-unstyled">
                      <li>
                        <NavLink
                          to={"/physics-overview"}
                          className="menu-links list-group-item list-group-item-action"
                          type="button"
                          onClick={() => {
                            document
                              .querySelector(".phone")
                              .classList.toggle("active3");
                          }}
                        >
                          Studying Physics Overview
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to={"/undergraduates"}
                          className="menu-links list-group-item list-group-item-action"
                          type="button"
                          onClick={() => {
                            document
                              .querySelector(".phone")
                              .classList.toggle("active3");
                          }}
                        >
                          Prospective Undergraduates
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to={"/current-undergraduates"}
                          className="menu-links list-group-item list-group-item-action"
                          type="button"
                          onClick={() => {
                            document
                              .querySelector(".phone")
                              .classList.toggle("active3");
                          }}
                        >
                          Current Undergraduates
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to={"/post-undergraduate"}
                          className="menu-links list-group-item list-group-item-action"
                          type="button"
                          onClick={() => {
                            document
                              .querySelector(".phone")
                              .classList.toggle("active3");
                          }}
                        >
                          Postgraduates
                        </NavLink>
                      </li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>{" "}
              <Accordion defaultActiveKey="">
                <Accordion.Item eventKey="0">
                  <Accordion.Header className="menu-navs">
                    <button
                      type="button"
                      className="list-group-item list-group-item-action m-accord menu-navs"
                    >
                      {" "}
                      Research
                    </button>
                  </Accordion.Header>
                  <Accordion.Body>
                    <ul class="list-unstyled">
                      <li>
                        <NavLink
                          to={"/research-overview"}
                          className="menu-links list-group-item list-group-item-action"
                          type="button"
                          onClick={() => {
                            document
                              .querySelector(".phone")
                              .classList.toggle("active3");
                          }}
                        >
                          Research Overview
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to={"/research-groups"}
                          className="menu-links list-group-item list-group-item-action"
                          type="button"
                          onClick={() => {
                            document
                              .querySelector(".phone")
                              .classList.toggle("active3");
                          }}
                        >
                          Research Groups
                        </NavLink>
                      </li>
                      <li>
                        <NavLink
                          to={"/research-programmes"}
                          className="menu-links list-group-item list-group-item-action"
                          type="button"
                          onClick={() => {
                            document
                              .querySelector(".phone")
                              .classList.toggle("active3");
                          }}
                        >
                          Research Programmes
                        </NavLink>
                      </li>{" "}
                      <li>
                        <NavLink
                          to={"/serminars"}
                          className="menu-links list-group-item list-group-item-action"
                          type="button"
                          onClick={() => {
                            document
                              .querySelector(".phone")
                              .classList.toggle("active3");
                          }}
                        >
                          Talks, Serminars, Events
                        </NavLink>
                      </li>{" "}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              <NavLink to={"/news-page"} className="menu-navs">
                {" "}
                <button
                  type="button"
                  class="list-group-item list-group-item-action"
                  onClick={() => {
                    document
                      .querySelector(".phone")
                      .classList.toggle("active3");
                  }}
                >
                  News
                </button>
              </NavLink>{" "}
              <NavLink to={"/alumni"} className="menu-navs">
                {" "}
                <button
                  type="button"
                  class="list-group-item list-group-item-action"
                  onClick={() => {
                    document
                      .querySelector(".phone")
                      .classList.toggle("active3");
                  }}
                >
                  Alumni
                </button>
              </NavLink>{" "}
            </div>
          </div>

          <svg
            className="x"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 220 400"
            height="400"
            width="220"
          >
            <g className="top-bars" stroke-width="4">
              <path className="bar bar1" d="M 178,20 H 202" />
              <path className="bar bar2" d="M 178,29 H 202" />
            </g>
          </svg>
          <div
            className="menu-click-area"
            onClick={() => {
              document.querySelector(".phone").classList.toggle("active3");
            }}
          ></div>
        </div>
      </div>
    </>
  );
}

export default NavBar;
